export const checkIfVariableIsInCode = (variable, code) => {
    const regex = new RegExp(`\\b${variable}\\b`);

    return regex.test(code);
};
